import type { IconProps } from './types';
import './icons.css';

export default function ArrowLeft({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 16}
      height={height || 16}
      viewBox="0 0 16 16"
      className={`icon icon-arrow-left ${className || ''}`}
    >
      <path
        fill="currentColor"
        d="M15 7.25a.75.75 0 0 1 0 1.5v-1.5ZM2 8l-.53.53L.94 8l.53-.53L2 8Zm7.03 5.97a.75.75 0 1 1-1.06 1.06l1.06-1.06ZM7.97.97a.75.75 0 0 1 1.06 1.06L7.97.97ZM15 8.75H2v-1.5h13v1.5Zm-7.03 6.28-6.5-6.5 1.06-1.06 6.5 6.5-1.06 1.06Zm-6.5-7.56 6.5-6.5 1.06 1.06-6.5 6.5-1.06-1.06Z"
      />
    </svg>
  );
}
